import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ProfileIcon from "../../Icons/ProfileIcon";
import Spinner from "../../components/Reusable/Spinner";
import { useEffect, useState } from "react";
import Skeleton from "../../components/Reusable/Skeleton";
const CurrentUserProfile = loadable(
  () => import("../../components/Auth/CurrentUserProfile")
);
const UserProfile = () => {
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { data: userProfileType, isLoading: isProfileDataLoading } = useGetHook(
    {
      queryKey: [`user-profile`],
      url: `${APIS.USER_PROFILE}`,
      params: {},
    }
  );

  return (
    <>
      <>
        <div
          className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
        >
          <ProfileIcon />
          <span className={tw`text-[#5E5757] font-bold text-xl`}>
            My Profile
          </span>
        </div>
        {isLoading || isProfileDataLoading ? (
          <Skeleton />
        ) : (
          <CurrentUserProfile
            profile={profile}
            userProfileType={userProfileType}
          />
        )}
      </>
    </>
  );
};
export default UserProfile;
